package app.nestbridge.feature.invitations.screen

import com.karawek.core.auth.model.OtpChannel
import com.karawek.core.circuit.Parcelize
import com.slack.circuit.runtime.screen.Screen

@Parcelize
data class InvitationOtpVerificationScreen(
    val invitationId: String,
    val channel: OtpChannel,
    val destination: String,
) : Screen
